<template>
        <div>
                 <el-dialog
                        title="查看"
                        width="65%"
                        append-to-body
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        详情
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll">
                        <detailFormInspection v-if="type==1" :isWatch="true" :form="form" :projectList.sync="projectList" :cancelBtn="false"></detailFormInspection>
                        <detailFormMaintenance v-if="type==2" :form="form" :projectList.sync="projectList" :cancelBtn="false"></detailFormMaintenance>
                       
                </div>
                </el-dialog>
        </div>
</template>
<script>
import {upkeepDetail,deviceinspecttasklist} from "@/api/crmedical/device/taskManagement";
import detailFormInspection from "@/components/device/deviceInspectionRecord/deviceInspectionRecord.vue"
import detailFormMaintenance from "@/components/device/deviceKeepRecord/maintenanceRecoderAdd.vue"
import ComprehensiveRecord  from "@/views/crmedical/comprehensiveInspect/record/recordForm.vue"
export default {
        components:{detailFormInspection,detailFormMaintenance,ComprehensiveRecord},
        props:{
                projectList:{
                        type:Array,
                        default(){
                                return []
                        }
                }
        },
        data(){
                return{
                        loading:false,
                        form:{},
                        dialogVisible:false,
                        dialogFull:false,
                        type:1,

                }
        },
        methods:{
                openDialog(row,type){
                        this.type = type;
                        this.loading = true;
                        this.dialogVisible = true;
                        this.initData(row.id,type);
                },
                async initData(id,type){
                        if(type == 1){
                                await deviceinspecttasklist({id:id}).then(res=>{
                                        this.form = res.data;
                                }).catch(err=>{
                                        this.loading = false;  
                                })
                        }else if(type == 2){
                                await upkeepDetail({id:id}).then(res=>{
                                        this.form = res.data;
                                }).catch(err=>{
                                        this.loading = false;  
                                })
                        }
                        
                        this.loading = false;
                }
        }
}
</script>